import { FC } from 'react';

import { Checkbox, Col, Form, FormInstance, Radio, Row, Select } from 'antd';
import { RadioChangeEvent } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ParticipationStatus, ScenarioForm } from '@/types/scenario';

type Props = {
  disabled?: boolean;
  form: FormInstance<ScenarioForm>;
};

const ElektricityMarketParticipation: FC<Props> = ({
  form,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const participationStatusOptions = [
    {
      label: t('components.participationStatus.doNotParticipate'),
      value: ParticipationStatus.DoNotParticipate.toString(),
    },
    {
      label: t('components.participationStatus.dependsOnModel'),
      value: ParticipationStatus.DependsOnTheModel.toString(),
    },
  ];

  // const modelTypeOptions: SelectProps['options'] = [
  //   {
  //     key: 'feed_in_tariff_only',
  //     label: t(
  //       'scenario.form.electricityMarketParticipation.modelType.feedInTariffOnly'
  //     ),
  //     value: 'feed_in_tariff_only',
  //   },
  //   {
  //     key: 'market_only',
  //     label: t(
  //       'scenario.form.electricityMarketParticipation.modelType.marketOnly'
  //     ),
  //     value: 'market_only',
  //   },
  //   {
  //     key: 'hybrid',
  //     label: t('scenario.form.electricityMarketParticipation.modelType.hybrid'),
  //     value: 'hybrid',
  //   },
  // ];

  const handleApplicationChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    form.setFieldValue('cAndISegment', value);
  };

  return (
    <Form.Item
      className="p-16 pb-40"
      style={{
        border: '0.5px solid',
        borderRadius: '10px',
        borderColor: theme.colors.grayLightAccent,
      }}
      wrapperCol={{ span: 24 }}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item<ScenarioForm>
            wrapperCol={{ span: 24 }}
            name="gridActions"
            label={t(
              'scenario.form.electricityMarketParticipation.gridActions.label'
            )}
            rules={[{ required: false }]}
          >
            <Checkbox.Group disabled={disabled}>
              <Checkbox value="sellToGrid">
                {t(
                  'scenario.form.electricityMarketParticipation.gridActions.sellToGrid'
                )}
              </Checkbox>
              <Checkbox value="purchaseFromGrid">
                {t(
                  'scenario.form.electricityMarketParticipation.gridActions.purchaseFromGrid'
                )}
              </Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item<ScenarioForm>
            name="cAndISegment"
            label={t(
              'scenario.form.electricityMarketParticipation.application.label'
            )}
            rules={[
              {
                required: true,
                message: t(
                  'scenario.form.electricityMarketParticipation.application.requiredMessage'
                ),
              },
            ]}
          >
            <Radio.Group
              onChange={handleApplicationChange}
              disabled={disabled}
              value={form.getFieldValue('cAndISegment')}
            >
              <Radio value={1}>
                {t(
                  'scenario.form.electricityMarketParticipation.application.behindTheMeter'
                )}
              </Radio>
              <Radio value={0}>
                {t(
                  'scenario.form.electricityMarketParticipation.application.frontOfTheMeter'
                )}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {/* <Form.Item<ScenarioForm>
        wrapperCol={{ span: 12 }}
        className="pr-32"
        name="modelType"
        label={t(
          'scenario.form.electricityMarketParticipation.modelType.label'
        )}
        rules={[
          {
            required: true,
            message: t(
              'scenario.form.electricityMarketParticipation.modelType.requiredMessage'
            ),
          },
        ]}
      >
        <Select
          disabled={disabled}
          options={modelTypeOptions}
          placeholder={t(
            'scenario.form.electricityMarketParticipation.modelType.placeholder'
          )}
        />
      </Form.Item> */}
      <Row>
        <Col className="pr-8" span={12}>
          <Form.Item<ScenarioForm>
            wrapperCol={{ span: 24 }}
            className="pr-8"
            name="pfcParticipation"
            label={t(
              'scenario.form.electricityMarketParticipation.pfcParticipation.label'
            )}
            rules={[
              {
                required: true,
                message: t(
                  'scenario.form.electricityMarketParticipation.pfcParticipation.requiredMessage'
                ),
              },
            ]}
          >
            <Select
              disabled={disabled}
              options={participationStatusOptions}
              placeholder={t(
                'scenario.form.electricityMarketParticipation.pfcParticipation.placeholder'
              )}
            />
          </Form.Item>
        </Col>
        <Col className="pl-8" span={12}>
          <Form.Item<ScenarioForm>
            wrapperCol={{ span: 24 }}
            className="pr-8"
            name="sfcParticipation"
            label={t(
              'scenario.form.electricityMarketParticipation.sfcParticipation.label'
            )}
            rules={[
              {
                required: true,
                message: t(
                  'scenario.form.electricityMarketParticipation.sfcParticipation.requiredMessage'
                ),
              },
            ]}
          >
            <Select
              disabled={disabled}
              options={participationStatusOptions}
              placeholder={t(
                'scenario.form.electricityMarketParticipation.sfcParticipation.placeholder'
              )}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};

export default ElektricityMarketParticipation;
